import { Resource } from "react-admin";
import React from "react";

export default <Resource name="roles" />;



// WEBPACK FOOTER //
// ./src/resources/Roles/index.js